import { render } from "./index.vue?vue&type=template&id=b80359e0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Work/Projects/Pocketkey/qrdynamic/qrdynamic-admin/qrdynamic-admin-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__